
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/gallabox-raises-1.2-million-to-help-smbs",
      function () {
        return require("private-next-pages/news/gallabox-raises-1.2-million-to-help-smbs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/gallabox-raises-1.2-million-to-help-smbs"])
      });
    }
  